/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiResultOfVoid
 */
export interface ApiResultOfVoid {
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfVoid
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfVoid
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfVoid
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfVoid
     */
    result?: ApiResultOfVoidResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfVoidResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfVoidFromJSON(json: any): ApiResultOfVoid {
    return ApiResultOfVoidFromJSONTyped(json, false);
}

export function ApiResultOfVoidFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfVoid {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfVoidToJSON(value?: ApiResultOfVoid | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

